import React, { useEffect, useState } from "react"
import Breadcrumb from "../../components/Common/Breadcrumb"
import { Card, CardBody, Col, Container, Input, Row, Table } from "reactstrap"
import {
  FaChevronLeft,
  FaChevronRight,
  FaPen,
  FaPlus,
  FaTrash,
} from "react-icons/fa6"
import Logo from "../../assets/images/logo.png"
import Swal from "sweetalert2"
import AddClubModal from "./AddClub"
import EditClubModal from "./EditClub"
import { fetchData, FetchDeleteData } from "utils/Common_api_functions"
import Loader from "components/Loader/loader"
import moment from "moment"

const ClubsIndex = () => {
  const imageBasePath = process.env.REACT_APP_IMAGE_PATH
  const [addModalOpen, setAddModalOpen] = useState(false)
  const [editModalOpen, setEditModalOpen] = useState(false)
  const [data, setData] = useState([])
  const [allClubs, setAllClubs] = useState([])
  const [selectedClub, setSelectedClub] = useState(null)
  const [loading, setLoading] = useState(false)

  const [searchString, setSearchString] = useState("")

  useEffect(() => {
    if (searchString !== "") {
      const filteredData = data.filter(item =>
        item.clubName.toLowerCase().includes(searchString.toLowerCase())
      )
      setAllClubs(filteredData)
      setPage(1)
    } else {
      setAllClubs(data)
    }
  }, [searchString, data])

  useEffect(() => {
    getClubs()
  }, [])

  async function getClubs() {
    const APIData = await fetchData(setLoading, "club")

    if (APIData?.success) {
      setAllClubs(APIData?.clubs)
      setData(APIData?.clubs)
    }
  }

  const handleEditClick = club => {
    setSelectedClub(club)
    setEditModalOpen(true)
  }

  const [page, setPage] = useState(1)
  const [items_perpage, setItemsPerPage] = useState(10)

  useEffect(() => window.scrollTo(0, 0), [])

  const total_pages = Math.ceil(allClubs?.length / items_perpage)

  const final_data = allClubs.slice(
    (page - 1) * items_perpage,
    page * items_perpage
  )

  const changePage = pagecount => {
    if (pagecount > 0 && pagecount <= total_pages) {
      setPage(pagecount)
      window.scrollTo(0, 0)
    }
  }

  const handleDelete = (userId) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This action will permanently delete the Club.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then(async result => {
      if (result.isConfirmed) {
        try {
          const res = await FetchDeleteData(setLoading ,  `club` , userId)

          if (res?.data?.success) {
            Swal.fire("Deleted!", "Club has been deleted.", "success")
            getClubs()
          } else {
            Swal.fire(
              "Error",
              res?.data?.message || "Something went wrong.",
              "error"
            )
          }
        } catch (error) {
          Swal.fire(
            "Error",
            "An error occurred while deleting the Club.",
            "error"
          )
          console.error(error)
        }
      }
    })
  }

  return (
    <div className="page-content">
      <Container fluid>
        {loading && <Loader />}
        <Breadcrumb title="" breadcrumbItem="Clubs" />

        <Row>
          <Col lg="12">
            <Card>
              <CardBody>
                <div className="d-flex justify-content-between align-items-center">
                  <h4 className="text-black fw-bold ps-1 mb-0">Clubs</h4>
                  <div className="d-flex gap-3">
                    <div className="form-group">
                      <Input
                        placeholder="Search Clubs"
                        value={searchString}
                        onChange={e => setSearchString(e.target.value)}
                      />
                    </div>
                    <button
                      className="btn btn-add"
                      onClick={() => setAddModalOpen(true)}
                    >
                      <FaPlus className="me-1" size={14} />
                      Add Club
                    </button>
                  </div>
                </div>
                <div className="mt-3">
                  <Table responsive bordered className="rounded-3">
                    <thead className="table-primary text-dark">
                      <tr>
                        <th>Sr No.</th>
                        <th>Logo</th>
                        <th>Club Name</th>
                        <th>Theme Color</th>
                        <th>Font Color</th>
                        <th>Created At</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {final_data.map((club, index) => (
                        <tr key={club.id}>
                          <td>{index + 1}</td>
                          <td>
                            <img
                              src={`${imageBasePath}${club?.clubImage}` || Logo}
                              alt={club.name}
                              width="50"
                              height="30"
                              style={{
                                borderRadius: "5px",
                                objectFit: "cover",
                              }}
                            />
                          </td>
                          <td>{club.clubName}</td>
                          <td>
                            <div
                              style={{
                                width: "30px",
                                height: "30px",
                                backgroundColor: club.clubThemeColor,
                                borderRadius: "5px",
                              }}
                            ></div>
                          </td>
                          <td>
                            <div
                              style={{
                                width: "30px",
                                height: "30px",
                                backgroundColor: club.clubFontColor,
                                borderRadius: "5px",
                              }}
                            ></div>
                          </td>
                          <td>{moment(club.createdAt).format("DD-MM-YYYY")}</td>
                          <td>
                            <button
                              className="btn btn-sm btn-primary me-2"
                              onClick={() => handleEditClick(club)}
                            >
                              <FaPen size={12} />
                            </button>
                            <button
                              className="btn btn-sm btn-danger"
                              onClick={() => handleDelete(club?._id)}
                            >
                              <FaTrash size={12} />
                            </button>
                          </td>
                        </tr>
                      ))}
                      {final_data.length === 0 && (
                        <tr>
                          <td colSpan={7} className="text-center">
                            No Data Found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>
                <div className="d-flex align-items-center justify-content-between my-2 px-2">
                  <p className="mb-0 fs-6">
                    Showing {final_data?.length} out of {allClubs?.length}{" "}
                    Clubs.
                  </p>
                  <div className="d-flex justify-content-md-start justify-content-center flex-wrap">
                    <div
                      className={`bd-number-pagination cursor-pointer rounded-2 me-1 fs-6`}
                      onClick={() => changePage(page - 1)}
                      style={{ cursor: "pointer" }}
                    >
                      <FaChevronLeft />
                    </div>
                    {(() => {
                      const maxVisiblePages = 5
                      const startPage = Math.max(
                        1,
                        page - Math.floor(maxVisiblePages / 2)
                      )
                      const endPage = Math.min(
                        total_pages,
                        startPage + maxVisiblePages - 1
                      )
                      const visiblePages = []

                      for (let i = startPage; i <= endPage; i++) {
                        visiblePages.push(i)
                      }

                      return visiblePages.map(pagecount => (
                        <div
                          key={pagecount}
                          className={`bd-number-pagination cursor-pointer rounded-2 me-1 fs-6 ${
                            page === pagecount ? "activepage" : ""
                          }`}
                          style={{ cursor: "pointer" }}
                          onClick={() => changePage(pagecount)}
                        >
                          {pagecount < 10 ? "0" + pagecount : pagecount}
                        </div>
                      ))
                    })()}
                    <div
                      className={`bd-number-pagination cursor-pointer rounded-2 ms-0 fs-6`}
                      onClick={() => changePage(page + 1)}
                      style={{ cursor: "pointer" }}
                    >
                      <FaChevronRight />
                    </div>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>

        {/* Add Modal */}
        <AddClubModal
          isOpen={addModalOpen}
          toggle={() => setAddModalOpen(!addModalOpen)}
          onSuccess={getClubs}
        />

        {/* Edit Modal */}
        <EditClubModal
          isOpen={editModalOpen}
          toggle={() => setEditModalOpen(false)}
          clubData={selectedClub}
          onSuccess={getClubs}
        />
      </Container>
    </div>
  )
}

export default ClubsIndex
